import React from 'react';
import { Button, ColorPicker, Flex, theme } from 'antd';
import {
  BorderOutlined,
  AudioOutlined,
  HighlightOutlined,
  EyeOutlined,
  EyeInvisibleOutlined,
  BookOutlined,
  CommentOutlined,
  DragOutlined,
} from '@ant-design/icons';

function Toolbar({
  navBarVisible,
  setNavBarVisible,
  thumbnailsVisible,
  setThumbnailsVisible,
  drawMode,
  setDrawMode,
  color,
  setColor,
}) {
  const { token: { colorBgContainer, borderRadiusLG, colorBgLayout } } = theme.useToken();

  return (
    <Flex
      gap={16}
      align="center"
      justify='center'
      style={{
        // margin: '16px',
        padding: '8px 16px',
        background: colorBgLayout,
        borderRadius: borderRadiusLG,
      }}
    >
      {/* <Button
        icon={navBarVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        onClick={() => setNavBarVisible(v => !v)}
      >
        {navBarVisible ? 'Hide Navigation' : 'Show Navigation'}
      </Button>
      <Button
        icon={thumbnailsVisible ? <EyeInvisibleOutlined /> : <EyeOutlined />}
        onClick={() => setThumbnailsVisible(v => !v)}
      >
        {thumbnailsVisible ? 'Hide Thumbnails' : 'Show Thumbnails'}
      </Button> */}
      <Button
        size='large'
        icon={<DragOutlined />}
      />
      <Button
        size='large'
        icon={<BorderOutlined />}
        type={drawMode === 'select' ? 'primary' : 'default'}
        onClick={() => setDrawMode('select')}
      />
      <Button
        size='large'
        icon={<HighlightOutlined />}
        type={drawMode === 'draw' ? 'primary' : 'default'}
        onClick={() => setDrawMode(drawMode === 'draw' ? 'select' : 'draw')}
      />
      <Button
        size='large'
        icon={<AudioOutlined />}
        type={drawMode === 'voice' ? 'primary' : 'default'}
        onClick={() => setDrawMode('voice')}
      />
      <Button
        size='large'
        icon={<BookOutlined />}
        type={drawMode === 'voice' ? 'primary' : 'default'}
        onClick={() => setDrawMode('voice')}
      />
      <Button
        size='large'
        icon={<CommentOutlined />}
        type={drawMode === 'voice' ? 'primary' : 'default'}
        onClick={() => setDrawMode('voice')}
      />
      <ColorPicker
        size='large'
        defaultValue={color}
        value={color}
        onChange={e => setColor(e.target.value)}
        showText />
    </Flex>
  );
}

export default Toolbar;